import PropTypes from "prop-types";
import ActionDropdown from "./ActionDropdown";

const ProfileCard = ({
  name,
  profileId,
  dateCreated, // To be deprecated...
  createDate,
  status,
  profStatus,
  variant,
  selected,
  actions,
}) => {
  // Define background and border colors for each variant
  const variants = {
    teal: {
      bg: "from-teal-50 to-teal-300",
      border: "border-teal-300",
    },
    green: {
      bg: "from-lime-50 to-lime-400",
      border: "border-lime-400",
    },
    orange: {
      bg: "from-orange-50 to-orange-300",
      border: "border-orange-300",
    },
    purple: {
      bg: "from-fuchsia-50 to-fuchsia-500",
      border: "border-fuchsia-500",
    },
    indigo: {
      bg: "from-indigo-50 to-indigo-500",
      border: "border-indigo-500",
    },
  };

  // Fallback to the teal variant if an invalid variant is passed
  const { bg, border } = variants[variant] || variants.teal;

  // Map status values to human-readable text
  const profStatusText =
    profStatus === "A"
      ? "Active"
      : profStatus === "P"
      ? "Pending"
      : profStatus === "S"
      ? "Suspended"
      : profStatus === "D"
      ? "Deactivated"
      : "Unknown";

  return (
    <div
      className={`bg-gradient-to-r mt-2 ${bg} ${border} border-l-4 p-4 rounded-lg shadow-md w-full max-w-[300px] ${
        selected ? "border-4 border-teal-700" : ""
      }`}
    >
      <div className="flex justify-between items-center relative">
        <h3
          className={`block text-sm font-semibold text-gray-900 mb-2 relative transition-all ${
            selected ? "mt-3" : ""
          }`}
        >
          Profile Name
          {selected && (
            <span className="absolute -top-7 -left-4 bg-teal-700 text-white text-xs font-bold px-2 py-1 shadow-md">
              ✓
            </span>
          )}
        </h3>
        <div className="flex items-center gap-2">
          {status && (
            <div className="inline-block px-3 py-1 text-xs font-semibold rounded-full text-teal-700 bg-yellow-400">
              {status}
            </div>
          )}

          {profStatus && (
            <div
              className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
                profStatusText === "Active"
                  ? "text-[#16A34A] bg-[#DCFCE7]"
                  : profStatusText === "Pending"
                  ? "text-[#CA8A04] bg-[#FEF9C3]"
                  : profStatusText === "Suspended"
                  ? "text-[#EF4444] bg-[#FEE2E2]"
                  : "text-gray-500 bg-gray-200"
              }`}
            >
              {profStatusText}
            </div>
          )}

          {actions && actions.length > 0 && (
            <ActionDropdown actions={actions} />
          )}
        </div>
      </div>
      <p className="text-gray-900 text-sm font-medium">{name}</p>
      <div className="flex justify-between items-center mt-4">
        <div>
          <h4 className="block text-sm font-semibold text-gray-900 mb-2">
            Profile ID
          </h4>
          <p className="text-gray-900 text-sm font-medium">{profileId}</p>
        </div>
        <div>
          <h4 className="block text-sm font-semibold text-gray-900 mb-2">
            Date Created
          </h4>
          <p className="text-gray-900 text-sm font-medium">{dateCreated || createDate}</p>
        </div>
      </div>
    </div>
  );
};

// Define PropTypes for the component
ProfileCard.propTypes = {
  name: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  dateCreated: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  profStatus: PropTypes.oneOf(["A", "P", "S"]),
  variant: PropTypes.oneOf(["teal", "green", "orange", "purple", "indigo"]),
  selected: PropTypes.bool,
  actions: PropTypes.array,
};

ProfileCard.defaultProps = {
  variant: "teal",
  selected: false,
  actions: [],
};

export default ProfileCard;
